<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .footer {
    width: calc(100% - 2 * utils.in_rem(24px));
    display: flex;
    justify-content: flex-end;
    padding: utils.in_rem(12px) 0;
    gap: utils.in_rem(16px);
    margin: 0 utils.in_rem(24px);
    border-top: 1px solid colors.get(interfaceSwGrey_10);
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  export let cancel = () => {};
  export let submit = () => {};
  export let disabled = false;
</script>

<div class="footer">
  <Button class="flex-1" onclick={cancel} kind="ghost-blue">Cancel</Button>
  <Button class="flex-1 {disabled ? 'disabled' : ''}" onclick={submit}>
    Submit
  </Button>
</div>
